import {setPrice} from "../changeCount/changeCount";
import {fetchData} from "../../utils/common";
import {changeAmountCount} from "../cart";
import {AddCartTypes} from "../../utils/consts";

const removeItem = ({cart}) => {
  const cartItemsElements = cart.querySelectorAll(`.js-cart-item`);
  const totalPriceElement = cart.querySelector(`.js-total`);
  const parnetTotalPriceElement = totalPriceElement.closest(`.cart__definition`);
  const discountElement = cart.querySelector(`.js-discount`);
  const discountContainerElement = cart.querySelector(`.js-discount-box`);
  const countForm = cart.querySelector(`.js-count`);
  const URL = `/basket/delete`;
  // const URL = `/data/data.json`;

  cartItemsElements.forEach((item) => {
    const state = {
      current: {},
      id: item.dataset.id,
    };

    item.addEventListener(`click`, async (evt) => {
      if (
        evt.target.classList.contains(`js-cart-remove`) ||
        evt.target.closest(`.js-cart-remove`)
      ) {
        evt.preventDefault();
        const {price, discount} = await fetchData(URL, state);

        if (price || price === 0) {
          setPrice(price, discount, totalPriceElement, discountContainerElement, discountElement);
          changeAmountCount(countForm.count.value, AddCartTypes.MINUS);
          item.remove();
        } else {
          console.log(`Ошибка при получении цены`);
        }
      }
    });
  });
};

export default removeItem;
